export const statuses = {
  closed: 'Fechado',
  sent: 'Enviado',
  analyzed: 'Analisado',
  in_appeal: 'Em recurso',
  settled: 'Baixado',
  canceled: 'Cancelado',
};

export const icons = {
  closed: 'lock',
  sent: 'paper-plane',
  analyzed: 'search-dollar',
  in_appeal: 'gavel',
  settled: 'check-circle',
  canceled: 'ban',
};

export function getName(value) {
  return statuses[value] || value;
}

export function getIcon(value) {
  return icons[value] || 'circle';
}

export function statusClass(value) {
  return `batch-status-${value}`;
}
